export var ALL_DAY_LABEL = 'All day';
export var INPUT_DATE_FORMAT = 'HH:mm:ss';
export var DAYS_BY_VALUE = {
  A_MON: 1,
  B_TUE: 2,
  C_WED: 3,
  D_THU: 4,
  E_FRI: 5,
  F_SAT: 6,
  G_SUN: 7
};